'use client'

import { createContext, PropsWithChildren, ReactElement, useContext, useState } from 'react'
import { useStore } from 'zustand'
import { createOurStore } from '@/stores/store'
import { AppStore } from '@/types/store.types'

export type StoreApi = ReturnType<typeof createOurStore>

export const StoreContext = createContext<StoreApi | undefined>(
  undefined,
)

type Props = {
  prefix: string
  timezone?: string
}

export const StoreProvider = ({
  children,
  prefix,
  timezone,
}: PropsWithChildren<Props>): ReactElement<HTMLElement> => {
  const [store] = useState(() => createOurStore(prefix, timezone))

  return (
    <StoreContext.Provider value={store}>
      {children}
    </StoreContext.Provider>
  )
}

export const useOurStore = <T, >(
  selector: (store: AppStore) => T,
): T => {
  const storeContext = useContext(StoreContext)

  if (!storeContext) {
    throw new Error('useOurStore must be used within StoreProvider')
  }

  return useStore(storeContext, selector)
}
